import { render, staticRenderFns } from "./YlHotelProductList.vue?vue&type=template&id=c1bb6e34&scoped=true"
import script from "./YlHotelProductList.vue?vue&type=script&lang=js"
export * from "./YlHotelProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bb6e34",
  null
  
)

export default component.exports